import { makeAutoObservable } from 'mobx'
import { NPS_PREVIEW_REPLY_SCORE } from 'pages/surveys/lib/npsCategories'
import {
  NPS_QUESTION_COMPANY_PLACEHOLDER,
  NPS_QUESTION_TEXT_PREFIX,
  NPS_QUESTION_TEXT_SUFFIX,
  getNpsQuestionText,
} from 'pages/surveys/lib/npsQuestionText'
import { type IPreviewBubble } from 'pages/surveys/ui/SurveyView/ui/Preview/Preview'

export class NpsQuestionStore {
  companyName = ''
  error = ''

  constructor(initialCompanyName?: string | null) {
    this.companyName = initialCompanyName ?? ''
    makeAutoObservable(this)
  }

  private get _parts() {
    const trimmed = this.companyName.trim()
    return [
      { text: NPS_QUESTION_TEXT_PREFIX },
      { text: trimmed || NPS_QUESTION_COMPANY_PLACEHOLDER, isPlaceholder: !trimmed },
      { text: NPS_QUESTION_TEXT_SUFFIX },
    ]
  }

  get text(): string {
    return getNpsQuestionText(this.companyName.trim())
  }

  get previewBubble(): IPreviewBubble[] {
    return [
      {
        id: 'nps-question',
        direction: 'outbound',
        parts: this._parts,
      },
      {
        id: 'nps-question-reply',
        direction: 'inbound',
        parts: [{ text: String(NPS_PREVIEW_REPLY_SCORE) }],
      },
    ]
  }

  setCompanyName = (value: string) => {
    this.companyName = value
    if (this.error) this.error = ''
  }

  setError = (value: string) => {
    this.error = value
  }
}
